import { cn } from '../lib/cn';

// Shimmer skeleton. Content-shaped placeholder that hints at what's loading.
// Variants pre-set common footprints so callers don't eyeball sizes.
export function Skeleton({ className, variant, ...rest }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'relative overflow-hidden rounded-xl bg-[hsl(var(--bg-raised))]',
        'after:absolute after:inset-0 after:animate-shimmer after:bg-shimmer-line',
        {
          card: 'h-32 w-full rounded-2xl',
          avatar: 'h-10 w-10 rounded-full',
          text: 'h-3 w-full rounded',
          'text-lg': 'h-5 w-2/3 rounded',
          button: 'h-10 w-28 rounded-lg',
          chart: 'h-48 w-full rounded-2xl',
          pill: 'h-6 w-20 rounded-full',
          tile: 'h-28 w-full rounded-xl',
        }[variant],
        className
      )}
      {...rest}
    />
  );
}

// Convenience: a stack of text rows that mimics a paragraph.
export function SkeletonText({ rows = 3, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          variant="text"
          className={i === rows - 1 ? 'w-4/5' : 'w-full'}
        />
      ))}
    </div>
  );
}

export default Skeleton;
